import { Component } from 'react';

export interface CircleDotProps {
  cx?: number;
  cy?: number;
  payload?: {
    generatedDataPoint?: boolean;
    score?: string;
  };
  stroke?: string;
  strokeWidth?: number;
  customColor?: (score: string) => string;
}

export class CircleDot extends Component<CircleDotProps> {
  render() {
    const { cx, cy, payload, strokeWidth, stroke, customColor } = this.props;
    if (payload?.generatedDataPoint) {
      return null;
    }
    return <circle cx={cx} cy={cy} r="3" fill={customColor?.(payload?.score) || stroke} stroke={customColor?.(payload?.score) || stroke} strokeWidth={strokeWidth} />;
  }
}
